import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import React, { Component } from 'react';

import { setActiveSubLayer } from '../../../actions/layersActions';
import { OTHER_IMAGERY } from '../../../constants/mapLayerIds';

import { PanelCards } from '../../Panel';
import OtherImageryPreview from '../../../components/cards/OtherImagery/OtherImageryPreview';
import OtherImageryEvents from '../../../components/cards/OtherImagery/OtherImageryEvents';
import {
  getVendorLayers,
  getNextEventId,
  getPrevEventId,
} from '../../../selectors/otherImagerySelectors';
import {
  getActiveSubLayer,
  getActiveSubLayerId,
} from '../../../selectors/layerSelectors';
import { FHA, HARVEST, PLANTING, WEATHER } from '../../../constants/cards';

export class OtherImageryPanel extends Component {
  handleSelectEvent = (activeSubLayer) => {
    const { index, setActiveSubLayer: setActiveSubLayerProp } = this.props;
    setActiveSubLayerProp(OTHER_IMAGERY, activeSubLayer, index);
  };

  handleLeftClickPreview = () => {
    const {
      index,
      prevEventId,
      setActiveSubLayer: setActiveSubLayerProp,
    } = this.props;
    setActiveSubLayerProp(OTHER_IMAGERY, prevEventId, index);
  };

  handleRightClickPreview = () => {
    const {
      index,
      nextEventId,
      setActiveSubLayer: setActiveSubLayerProp,
    } = this.props;
    setActiveSubLayerProp(OTHER_IMAGERY, nextEventId, index);
  };

  render() {
    const {
      activeSubLayer,
      activeSubLayerId,
      index,
      isCollapsed,
      isSplitViewEnabled,
      layers,
      locale,
      collapsePanel,
    } = this.props;
    const vendors = Object.keys(layers);

    const firstCard =
      isSplitViewEnabled && isCollapsed ? (
        <OtherImageryPreview
          date={activeSubLayer.date}
          handleLeftClick={this.handleLeftClickPreview}
          handleRightClick={this.handleRightClickPreview}
          layer={activeSubLayerId.layer}
        />
      ) : (
        <OtherImageryEvents
          activeSubLayerId={activeSubLayerId}
          collapsePanel={collapsePanel}
          handleSelectEvent={this.handleSelectEvent}
          layers={layers}
          locale={locale}
          vendors={vendors}
        />
      );

    const CARDS = [WEATHER, PLANTING, HARVEST, FHA];

    return (
      <PanelCards
        cards={CARDS}
        firstCard={firstCard}
        index={index}
        isCollapsed={isCollapsed}
        testId="otherImagery"
      />
    );
  }
}

function mapStateToProps(state, props) {
  return {
    activeSubLayer: getActiveSubLayer(state, props),
    activeSubLayerId: getActiveSubLayerId(state, props),
    layers: getVendorLayers(state, props),
    locale: state.app.locale,
    nextEventId: getNextEventId(state, props),
    prevEventId: getPrevEventId(state, props),
  };
}

function mapDispatchToProps(dispatch) {
  return { ...bindActionCreators({ setActiveSubLayer }, dispatch) };
}

OtherImageryPanel.propTypes = {
  activeSubLayer: PropTypes.object.isRequired,
  activeSubLayerId: PropTypes.object.isRequired,
  collapsePanel: PropTypes.func,
  index: PropTypes.number.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  isSplitViewEnabled: PropTypes.bool.isRequired,
  layers: PropTypes.object.isRequired,
  locale: PropTypes.string,
  nextEventId: PropTypes.object.isRequired,
  prevEventId: PropTypes.object.isRequired,
  setActiveSubLayer: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(OtherImageryPanel);
